import { render } from "./App.vue?vue&type=template&id=88fa23e6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=88fa23e6&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__